// extracted by mini-css-extract-plugin
export var active = "_2o-d";
export var blink = "_2o-e";
export var container = "_2o-5";
export var controls = "_2o-0";
export var controlsRight = "_2o-1";
export var fakeCursor = "_2o-c";
export var hidden = "_2o-b";
export var quillContainerSmall = "_2o-7";
export var quillEditor = "_2o-6";
export var quillEditorSmall = "_2o-8";
export var quillFormatButtons = "_2o-a";
export var quillToolbar = "_2o-9";
export var removePadding = "_2o-2";
export var state = "_2o-3";
export var stateTitle = "_2o-4";